export default class SwedishOrgNr {
    static validate(orgnr) {
        if (orgnr) {
            const orgnumber = orgnr.replace(/\D/g, '');

            if (orgnumber.length < 10 || orgnumber.length > 12 || orgnumber.length == 11) {
                return false;
            }

            return isValidLuhn(orgnumber);
        }

        return false;
    }
}

/**
 * Check if last digit of number is vald Luhn control digit
 * @param pnr
 * @returns {boolean}
 **/
function isValidLuhn(pnr) {
    let number;
    let checksum = 0;

    for (var i = pnr.length - 1; i >= 0; i--) {
        number = parseInt(pnr.charAt(i));

        if (i % 2 == 1) {
            checksum += number;
        } else {
            checksum += number * 2 > 9 ? number * 2 - 9 : number * 2;
        }
    }

    return checksum % 10 == 0;
}
